import { render, staticRenderFns } from "./basicSelect.vue?vue&type=template&id=b450b1d6&scoped=true&"
import script from "./basicSelect.vue?vue&type=script&lang=js&"
export * from "./basicSelect.vue?vue&type=script&lang=js&"
import style0 from "./basicSelect.vue?vue&type=style&index=0&id=b450b1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450b1d6",
  null
  
)

export default component.exports